import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ShareDataService } from '../../../shared/services/share-data.service';
import { IdleService } from '../../../shared/services/idle.service';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry, mergeMap } from 'rxjs/operators';
import { sharedBroadcast } from '../login/login.component';

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const router = inject(Router);
  const sharedService = inject(ShareDataService);
  const idleService = inject(IdleService);

    const isAssetRequest = req.url.startsWith('assets/') || req.url.includes('/assets/');
  if (isAssetRequest) {
    return next(req);
  }


  // Public APIs that don’t need auth token
  const publicAPIs = [
    'api/User/Login',
    'api/User/GetDeviceFormData',
    'api/User/InsertDeviceFormData',
    'https://api.ipify.org/?format=json',
  ];

  // Force logout via broadcast listener
  sharedBroadcast.onmessage = (message) => {
    if (message.data === 'logOut-inter') {
      idleService.toastMessageSignal.set({
        severity: 'success',
        summary: 'Logout',
        detail: 'You have been forcefully logged out. Please log in again',
      });
      window.location.reload();
    }
  };

  // Determine if it's a public API
  const isPublicAPI = publicAPIs.some((url) => req.url.includes(url));

  // 🔄 Always fetch the token fresh just before it's needed
  const freshToken = localStorage.getItem('Auth_token');

  // 🚫 If private API and token is missing, block and force logout
  if (!isPublicAPI && !freshToken) {
    idleService.toastMessageSignal.set({
      severity: 'success',
      summary: 'Logout',
      detail: 'No auth token found. Please log in again',
    });
    localStorage.clear();
    sharedBroadcast.postMessage('logOut-inter');
    return throwError(() => new Error('No auth token found.'));
  }

  // 📦 Set headers including Authorization only if required
  const headersConfig: any = {
    Accept: 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  };

  if (!isPublicAPI && freshToken) {
    try {
      headersConfig.Authorization = JSON.parse(freshToken);
    } catch (e) {
      headersConfig.Authorization = freshToken;
    }
  }

  const modifiedReq = req.clone({ setHeaders: headersConfig });

  return next(modifiedReq).pipe(
    // retry({
    //   count: 1, // Retry up to 3 times
    //   delay: (retryAttempt) => timer(retryAttempt * 1000) // Add a delay (e.g., 1s, 2s, 3s)
    // }),
    catchError((error) => handleHttpError(error, idleService, sharedService))
  );
};

function handleHttpError(
  error: any,
  idleService: IdleService,
  sharedService: ShareDataService
): Observable<never> {
  // console.error('HTTP Error:', error);

  const ERROR_MESSAGES = {
    UNAUTHORIZED: 'Unauthorized access. Logging out...',
  };

  switch (error.status) {
    case 401:
      if (!sharedService.isLogoutInitiated()) {
        console.warn(ERROR_MESSAGES.UNAUTHORIZED);
        sharedService.setLogoutInitiated(true);
        idleService.logout('Unauthorized','Intereptor 401 error');
      }
      break;
  }
  return throwError(() => error);
}
